export const TOKEN_STORAGE_KEY = 'beaw.auth.tokens';
export type Tokens = { access_token: string; refresh_token: string };
let memoryTokens: Tokens | null = null;
function parseTokens(raw: string | null): Tokens | null {
  try {
    const value = JSON.parse(raw || 'null');
    return typeof value?.access_token === 'string' && value.access_token &&
      typeof value?.refresh_token === 'string' && value.refresh_token ? value : null;
  } catch { return null; }
}
export function readTokens(): Tokens | null {
  try {
    const persisted = parseTokens(localStorage.getItem(TOKEN_STORAGE_KEY));
    if (persisted) return (memoryTokens = persisted);
    // Keep existing signed-in tabs working when upgrading the website.
    const legacy = parseTokens(sessionStorage.getItem(TOKEN_STORAGE_KEY));
    if (legacy) { rememberTokens(legacy); return legacy; }
    return (memoryTokens = null);
  } catch { return memoryTokens; }
}
export function rememberTokens(value: { access_token?: string; refresh_token?: string }) {
  if (!value.access_token || !value.refresh_token) return;
  memoryTokens = { access_token: value.access_token, refresh_token: value.refresh_token };
  try {
    localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(memoryTokens));
    sessionStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch { /* Keep the active session when browser storage is unavailable. */ }
}
export function clearTokens() {
  memoryTokens = null;
  try { localStorage.removeItem(TOKEN_STORAGE_KEY); } catch { /* Storage unavailable. */ }
  try { sessionStorage.removeItem(TOKEN_STORAGE_KEY); } catch { /* Storage unavailable. */ }
}
